import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import CodeEditor from '../components/CodeEditor'
import { usePreview } from '../components/PreviewContext'
import { CustomizerContext } from '../context/CustomizerContext'
import { useDelayedYText } from '../hooks/documentHooks'
import * as Y from 'yjs'

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

const ThemeEditor = ({ textName }) => {
  const { hotReloadPage } = usePreview()
  const { document } = useContext(CustomizerContext)
  const theme = document.get(textName, Y.XmlText)
  const currentTheme = useDelayedYText(theme)

  useEffect(() => {
    if (currentTheme) {
      hotReloadPage()
    }
  }, [currentTheme, hotReloadPage])

  return (
    <Container>
      <CodeEditor yText={theme} language='css' />
    </Container>
  )
}

export default ThemeEditor